var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBrochurePc(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_6257",
    "data-name": "Group 6257",
    transform: "translate(-1132 -102)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_967",
    "data-name": "Ellipse 967",
    transform: "translate(1132 102)",
    fill: "#fff",
    stroke: "#c4c4c4",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 15.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_15152",
    "data-name": "Path 15152",
    d: "M.537,16.656h13.6v2.267H.537ZM6.2.789v6.8H.537l6.8,6.8,6.8-6.8H8.47V.789Z",
    transform: "translate(1140.664 108.144)",
    fill: "#a33635"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrochurePc);
export default __webpack_public_path__ + "static/media/BrochurePC.d402d438f3a6955497696b4966cc9a15.svg";
export { ForwardRef as ReactComponent };